(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("cornerstone-dicom-parser-utf8"), require("jquery"), require("cornerstone-core"));
	else if(typeof define === 'function' && define.amd)
		define("cornerstoneArchiveImageLoader", ["cornerstone-dicom-parser-utf8", "jquery", "cornerstone-core"], factory);
	else if(typeof exports === 'object')
		exports["cornerstoneArchiveImageLoader"] = factory(require("cornerstone-dicom-parser-utf8"), require("jquery"), require("cornerstone-core"));
	else
		root["cornerstoneArchiveImageLoader"] = factory(root["dicomParser"], root["$"], root["cornerstone"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_39__, __WEBPACK_EXTERNAL_MODULE_40__, __WEBPACK_EXTERNAL_MODULE_99__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition